// @ts-strict-ignore
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@shared/custom-validators';
import { ProjectModel } from '@project/model/project.model';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { IsProjectType } from '@project/model/is-project-type';
import { ProjectComponentPresenter } from '../../../project-component.presenter';
import { FinalizeProjectComponent } from '@project/components/project/finalize-project/finalize-project.component';

@Component({
  standalone: false,
  selector: 'finalize-project-repetition',
  templateUrl: './finalize-project-repetition.component.html',
})
export class FinalizeProjectRepetitionComponent implements OnInit, OnDestroy {
  @Input() existingFNumber: string;
  public form: FormGroup;
  @Output() public finish = new EventEmitter<void>();

  public readonly fNumberTextInputName: string = 'fNumberTextInput';

  constructor(
    private bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private localeResourceManager: LocaleResourceManager,
    private projectModel: ProjectModel,
    private projectComponentPresenter: ProjectComponentPresenter,
  ) { }

  public ngOnInit(): void {
    let displayFNumber: string = '';
    if (this.existingFNumber && this.existingFNumber.length > 2) {
      displayFNumber = this.existingFNumber.substr(2);
    }
    const formData: any = {};
    formData[this.fNumberTextInputName] = new FormControl(displayFNumber,
      Validators.compose([CustomValidators.trimRequired, CustomValidators.maxLength(7), CustomValidators.minLength(7)]));
    this.form = this.formBuilder.group(formData);
  }

  private validateForm(): boolean {
    if (!this.form.controls[this.fNumberTextInputName].valid) {
      return false;
    }
    if (!this.form.controls.fNumberTextInput.value) {
      return false;
    }
    if (this.form.controls.fNumberTextInput.value.length < 6) {
      return false;
    }
    return true;
  }

  public ngOnDestroy(): void {
  }

  public close(closeTypeSuccess: boolean = false): void {
    this.bsModalRef.hide();
  }

  public finalizeButtonClickHandler(): void {
    if (!this.validateForm()) {
      return;
    }
    const finalFNumber: string = this.localeResourceManager.getValueByKey('finalizeProject.label.fNumberPreFix') + this.form.controls.fNumberTextInput.value;
    const data: Partial<FinalizeProjectComponent> = {
      mcsGds221LtlExport: IsProjectType.among(this.projectModel.currentProjectType, 'MCS', 'GDS', 'LTL', 'SPLICING_CONNECTOR_221'),
      fNumber: finalFNumber
    };
    this.projectComponentPresenter.showFinalizeProjectPopup(data);
    this.close();
  }
}
